import { Reducer } from 'redux'
import * as fromActions from '../actions/blockProgress.action'

export const initialState: any = {
  progress: {},
  loading: false,
}

export const reducer: Reducer<any> = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case fromActions.SET_LESSON_BLOCKS_PROGRESS:
      return {
        ...state,
        loading: true,
      }
    case fromActions.SET_LESSON_BLOCKS_PROGRESS_SUCESS:
      return {
        ...state,
        progress: {
          ...state.progress,
          [payload.id]: payload.data,
        },
        loading: false,
      }
    case fromActions.CURRENT_LESSON_BLOCKS_PROGRESS:
      return {
        ...state,
        loading: true,
      }
    case fromActions.CURRENT_LESSON_BLOCKS_PROGRESS_SUCESS:
      return {
        ...state,
        progress: {
          ...state.progress,
          [payload.id]: payload.data,
        },
        loading: false,
      }
    default:
      return {
        ...state,
      }
  }
}
